import { getUserCountrySpecInfo } from '../../../util/location';
import config from '../../../config';

const {
    maps: { supportedCountries },
} = config;

/**
 * Initialize phone code based on saved country code or user's country
 * @param {string} savedCountryCode - Previously saved country code (e.g., '+41')
 * @param {object} currentUser - Current user object with country info
 * @param {object} customSupportedCountries - Optional custom country config
 * @returns {string} Phone code with country prefix (e.g., '+41')
 */
export const initPhoneCode = (savedCountryCode, currentUser, customSupportedCountries = null) => {
    if (!currentUser || !currentUser.attributes || !currentUser.attributes.profile) {
        return '';
    }

    const { country } = currentUser.attributes.profile.publicData || {};

    if (!country) {
        return savedCountryCode || '';
    }

    const countriesConfig = customSupportedCountries || {
        ...supportedCountries,
        AT: {
            // Austria
            name: 'Austria',
            code: 'AT',
            phoneCode: '43',
        },
    };

    const { phoneCode } = getUserCountrySpecInfo(country, countriesConfig);

    return savedCountryCode || `+${phoneCode}`;
};
